import { useState } from "react";
import axios from "axios";
import { formatApiError } from "../../lib/formatApiError";
import { API } from "../../lib/constants";

export function WithdrawForm({ stats, onSuccess }) {
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  const [paymentDetails, setPaymentDetails] = useState("");
  const [withdrawError, setWithdrawError] = useState("");

  const handleWithdraw = async (e) => {
    e.preventDefault();
    setWithdrawError("");
    try {
      await axios.post(`${API}/affiliate/withdraw`, {
        amount: parseFloat(withdrawAmount),
        payment_method: paymentMethod,
        payment_details: paymentDetails,
      });
      setWithdrawAmount("");
      setPaymentDetails("");
      onSuccess();
    } catch (err) {
      setWithdrawError(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="bg-white border border-black p-6 mb-8" data-testid="withdraw-form">
      <h3 className="text-lg font-bold mb-4">Request Withdrawal</h3>
      {withdrawError && (
        <div className="bg-red-50 border border-red-500 text-red-700 p-3 mb-4 text-sm">{withdrawError}</div>
      )}
      <form onSubmit={handleWithdraw} className="space-y-4 max-w-md">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">Amount (Min $50)</label>
          <input
            type="number"
            min="50"
            max={stats?.pending_earnings || 0}
            step="0.01"
            value={withdrawAmount}
            onChange={(e) => setWithdrawAmount(e.target.value)}
            className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none"
            required
            data-testid="withdraw-amount"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">Payment Method</label>
          <select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none"
            data-testid="withdraw-method"
          >
            <option value="paypal">PayPal</option>
            <option value="bank_transfer">Bank Transfer</option>
          </select>
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">
            {paymentMethod === "paypal" ? "PayPal Email" : "Bank Account Details"}
          </label>
          <input
            type="text"
            value={paymentDetails}
            onChange={(e) => setPaymentDetails(e.target.value)}
            placeholder={paymentMethod === "paypal" ? "your@email.com" : "Account number, routing, etc."}
            className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none"
            required
            data-testid="withdraw-details"
          />
        </div>
        <button
          type="submit"
          className="bg-[#0066FF] text-white px-6 py-3 font-bold hover:bg-[#0052CC] transition-colors"
          data-testid="submit-withdraw"
        >
          Submit Withdrawal Request
        </button>
      </form>
    </div>
  );
}
